export function LogoWhiteLabel({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="71"
      height="44"
      viewBox="0.05 0 71 44"
      enableBackground="new 0.05 0 71 44"
    >
      <path
        fill="#E30613"
        d="M2.346 43.97H65.36c3.095 0 5.69-2.497 5.69-5.692V25.395c-34.252-.6-61.313 14.08-68.704 18.574"
      ></path>
      <path
        fill="#00497F"
        d="M71.05 22.4V.03H5.742C2.646.03.05 2.53.05 5.724V41.87c6.59-4.093 34.852-20.07 71-19.47"
      ></path>
      <path
        fill="#fff"
        d="M12.733 9.22c-.6-.7-1.2-1-1.998-1-.998 0-1.697.6-1.697 1.397 0 .7.4.998 1.898 1.598 1.396.5 1.896.8 2.496 1.2.698.597 1.098 1.495 1.098 2.595 0 2.396-1.697 4.094-4.293 4.094-1.798 0-3.097-.7-4.195-2.297L7.64 15.31c.6 1.1 1.498 1.597 2.598 1.597 1.098 0 1.896-.697 1.896-1.697 0-.498-.2-.898-.7-1.197-.198-.2-.698-.4-1.696-.7-2.197-.798-2.996-1.696-2.996-3.296 0-2.096 1.598-3.594 3.795-3.594 1.298 0 2.596.498 3.595 1.398l-1.4 1.4zM18.025 6.223h1.597l3.396 8.088 3.495-8.087h1.597l2.097 12.582H27.81l-1.097-7.59-3.396 7.69h-.7l-3.294-7.69-1.2 7.59H15.73zM37.597 9.817L35.8 14.212h3.495l-1.698-4.395zM35 16.21l-1.098 2.595h-2.597l5.292-12.582h1.8l5.19 12.582H41.09l-1.097-2.596H35z"
      ></path>
    </svg>
  );
}
